// @ts-nocheck
import { useAuthenticateWithSocial } from "@/api/auth";
import { useAuthenticateWithWallet } from "@/api/auth";
import { useAddUserWallet } from "@/api/wallet-management";
import { setToken, setUserId } from "@/helpers/localStorage";
import { ApiSupportedChain } from "@/providers/wallet";
import { useBotWallets } from "../../providers/wallet/useBotWallets";

import GradientBorderRadius from "@/ui/gradient-border-radius";
import { useDebouncedCallback } from "@mantine/hooks";
import { useWeb3Auth } from "@web3auth/modal-react-hooks";
//import { useNavigate } from "react-router";

const SignInHeaderBtn = () => {
  //const navigate = useNavigate();
  const { web3Auth, connect, isConnected } = useWeb3Auth();

  const { mutate: mutateWallet } = useAuthenticateWithWallet();
  const { mutate: mutateSocial } = useAuthenticateWithSocial();
  const { mutate: mutateAddUserWallet } = useAddUserWallet();
  const { ethersWallets, solanaWallets } = useBotWallets();

  const onLogin = async () => {
    await connect();
    if (!web3Auth) {
      return;
    }
    const { typeOfLogin } = await web3Auth.getUserInfo();
    const { idToken } = await web3Auth.authenticateUser();

    setToken(idToken);

    if (typeOfLogin) {
      mutateSocial(
        { token: idToken },
        {
          onSuccess(data) {
            if (data.isNewUser) {
              debouncedAddUserWallets();
            }
          },
        }
      );
      const { email } = await web3Auth.getUserInfo();

      setUserId(email || "");
    } else {
      mutateWallet({ token: idToken });
    }

    // navigate("/screener");
  };

  const addUserWallets = () => {
    if (ethersWallets?.length > 0 && solanaWallets?.length > 0) {
      ethersWallets.forEach((wallet) => {
        mutateAddUserWallet({
          address: wallet,
          chain: ApiSupportedChain.ETH,
        });
      });

      solanaWallets.forEach((wallet) => {
        mutateAddUserWallet({
          address: wallet,
          chain: ApiSupportedChain.SOL,
        });
      });
    }
  };

  const debouncedAddUserWallets = useDebouncedCallback(addUserWallets, 100, [
    ethersWallets,
    solanaWallets,
  ]);

  if (isConnected) {
    return null;
  }

  return (
    <div className="flex justify-center items-center gap-2">
      <div id="telegram-login-widget"></div>
      <GradientBorderRadius
        radius="bigger"
        gradient="50"
        className="bg-sing-in-button"
        hover="r-100"
      >
        <button
          onClick={onLogin}
          className="w-[9.3750rem] h-[1.875rem] text-transparent font-semibold text-xs leading-[1.1250rem] hover:text-white"
        >
          <span className="text-white">Sign In</span>
        </button>
      </GradientBorderRadius>
    </div>
  );
};

export default SignInHeaderBtn;
